import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiPermissions } from '@proto/integrationapp';
import { PermissionsWithSecret } from '../../integration-apps.types';

@Component({
  selector: 'app-integration-apps-permission-secrets',
  templateUrl: './integration-apps-permission-secrets.component.html',
  standalone: false
})
export class IntegrationAppsPermissionSecretsComponent implements OnInit {

  @Input() apiPermissions: ApiPermissions[] = [];
  @Input() isUpgrade: boolean = false;
  @Input() previousApiPermissions?: ApiPermissions[] = [];

  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();
  @Output() emitSecrets: EventEmitter<PermissionsWithSecret[]> = new EventEmitter<PermissionsWithSecret[]>();

  public permissionsWithSecret: PermissionsWithSecret[] = [];
  public accepted: boolean = false;

  public copied = false;
  private copiedTimeout?: ReturnType<typeof setTimeout>;

  ngOnInit(): void {
    const previousPermissionsByIdentifier = new Map(
      (this.previousApiPermissions ?? []).map(permissionSet => [permissionSet.identifier, permissionSet])
    );

    this.permissionsWithSecret = this.apiPermissions.map(permissionSet => {
      const previousPermission = previousPermissionsByIdentifier.get(permissionSet.identifier);

      return {
        identifier: permissionSet.identifier,
        scopes: permissionSet.scopes,
        generatedSecret: previousPermission?.scopes?.length ? undefined : this.generateAPISecret()
      };
    });
  }

  get hasGeneratedSecrets(): boolean {
    return this.permissionsWithSecret.some(
      permission => permission.generatedSecret !== undefined
    );
  }

  get hasMoreThanOnePermissionSet() {
    return this.permissionsWithSecret.length > 1;
  }

  public accept(v: boolean) {
    this.accepted = v;
  }

  onCancel() {
    this.cancel.emit();
  }

  hashAndInstall() {
    this.emitSecrets.emit(this.permissionsWithSecret);
  }

  // this creates a 20-character cryptographically random secret with the available chars in "alphabet"
  // the user needs to remember the secret to (for example) be able to grant the permissions to other services
  private generateAPISecret(length = 20): string {
    const alphabet = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789';
    const randomValues = new Uint32Array(length);
    crypto.getRandomValues(randomValues);
    return Array.from(randomValues, v => alphabet[v % alphabet.length]).join('');
  }

  showCopied(): void {
    this.copied = true;

    clearTimeout(this.copiedTimeout);
    this.copiedTimeout = setTimeout(() => {
      this.copied = false;
    }, 1200);
  }

  public getTranslationKeyFromScopeValue(scope: string): string {
    const scopeString = scope.replace(/\./g, '_');
    return 'integration-apps-permission-secrets_scope_text_' + scopeString;
  }

}
